// extracted by mini-css-extract-plugin
module.exports = {"AveregeScoreTitle":"AveragingScore_AveregeScoreTitle__17Oav","ScoreIcon":"AveragingScore_ScoreIcon__XKv83","AveregeScoreChart":"AveragingScore_AveregeScoreChart__1ixzT"};